<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="62"
    height="63"
    viewBox="0 0 62 63"
    fill="none"
  >
    <path
      d="M30.9993 10.1875C25.6491 10.1875 21.3118 14.5247 21.3118 19.875C21.3118 25.2253 25.6491 29.5625 30.9993 29.5625C36.3496 29.5625 40.6868 25.2253 40.6868 19.875C40.6868 14.5247 36.3496 10.1875 30.9993 10.1875Z"
      fill="#B7B2B5"
    />
    <path
      d="M20.666 34.7292C15.3158 34.7292 10.9785 39.0664 10.9785 44.4167V47.4864C10.9785 49.4322 12.3887 51.0913 14.3091 51.4049C25.3628 53.2096 36.6359 53.2096 47.6896 51.4049C49.61 51.0913 51.0202 49.4322 51.0202 47.4864V44.4167C51.0202 39.0664 46.6829 34.7292 41.3327 34.7292H40.4521C39.9755 34.7292 39.5019 34.8045 39.0488 34.9525L36.8129 35.6826C33.0353 36.9161 28.9633 36.9161 25.1858 35.6826L22.9499 34.9525C22.4968 34.8045 22.0232 34.7292 21.5466 34.7292H20.666Z"
      fill="#B7B2B5"
    />
  </svg>
</template>